const breakpoints = {
    xs: 0,
    xs1: 366,
    xs2: 480,
    sm: 768,
    sm2: 960,
    md: 1280,
    // Laptop
    lg: 1680,
    // Desktop
    xl: 2200,
}; //TODO: should be used as it is (for ng) or should it respec the breakpoints from sazkabet website?

export const ResponsiveUtils = {
    logDataLayer() {
        dataLayer.push({ page: { responseDesignCategory: this.getDataLayerResolution() } });
    },

    breakpointUp(breakpointName: keyof typeof breakpoints) {
        return window.matchMedia(`(min-width: ${breakpoints[breakpointName]}px)`).matches;
    },

    breakpointDown(breakpointName: keyof typeof breakpoints) {
        return window.matchMedia(`(max-width: ${breakpoints[breakpointName] - 1}px)`).matches;
    },

    isMobile() {
        return ngLoader.isMobile();
    },

    getDataLayerResolution() {
        let resolution = "mobile";

        if (this.breakpointUp("lg")) {
            resolution = "big desktop";
        } else if (this.breakpointUp("md")) {
            resolution = "small desktop";
        } else if (this.breakpointUp("sm")) {
            resolution = "tablet";
        }

        return resolution;
    },

    /**
     * Checks if user is browsing on iOS 13
     */
    isIpad() {
        return ngLoader.isIpad();
    },

    isSafari() {
        const userAgent = window.navigator.userAgent;
        const iOS = /iPad/i.exec(userAgent) || /iPhone/i.exec(userAgent);
        const webkit = /WebKit/i.exec(userAgent);
        return iOS && webkit && !/CriOS/i.exec(userAgent);
    },

    isIos() {
        return /iPhone|iPad/.test(navigator.userAgent) || ResponsiveUtils.isIpad();
    },

    isAndroid() {
        return /android|Android/.test(navigator.userAgent);
    },
};
